// extracted by mini-css-extract-plugin
module.exports = {"root":"_1VAYf","TextOnlyMenuButtonNSkin":"_14VId","textOnlyMenuButtonNSkin":"_14VId","linkElement":"_35v05","wrapper":"_1Szr4","label":"ccDUc"};